
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/homepage",
      function () {
        return require("private-next-pages/[lang]/homepage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/homepage"])
      });
    }
  